import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'certificate-layout',
  styleUrl: 'certificate-layout.css',
})
export class CertificateLayout {
  @Prop() showKelleyBuysYourCar: boolean = false;
  @Prop() hideLinks: boolean = false;

  render() {
    const layoutContainerClass = { 'font-open-sans box-shadow': true, 'pb-16': this.showKelleyBuysYourCar };
    return (
      <page-layout>
        <div class={layoutContainerClass}>
          <offer-certificate-header showKelleyBuysYourCar={this.showKelleyBuysYourCar} hideLinks={this.hideLinks} />
          <slot name="header" />
          <slot name="hero" />

          <div class="flex flex-col mdLrg:flex-row flex-wrap justify-between">
            <div class="flex-1">
              <slot name="left" />
            </div>
            <div class="flex-1">
              <slot name="right" />
            </div>
          </div>

          <div class="main my-4">
            <slot name="main" />
            <slot />
          </div>
          <slot name="modal" />
          <div class="footer">
            <slot name="footer" />
          </div>
        </div>
      </page-layout>
    );
  }
}
